export const getAppPageById = (payload: { id: number }) => ({
    type: "@saga/GET_APP_PAGE_BY_ID",
    payload
});